module.exports = __webpack_public_path__ + "media/slot-game/icecream-1-e06b9617.svg";